import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { IBreadCrumb } from '@interfaces/Components/Breadcrumb/Breadcrumb.interface';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Box, Grid } from '@mui/material';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';

const CustomBreadcrumbs: React.FC<IBreadCrumb> = ({
  setStepFlow,
  setStepSidebar,
  step,
  stepperTitle,
  crumbs,
  isWorkflow,
  activePath,
}) => {
  const [titlesArr, setTitlesArr] = React.useState([]);
  const crumbsArr = crumbs || [];
  const history = useHistory();

  // COMPONENTE DE HISTORIAL DE NAVEGACION

  // UTILIZADO POR...........................
  // - ASISTENCIAS / PEDIR GRUA
  // - DENUNCIAR SINIETRO

  useEffect(() => {
    setTitlesArr((old) => [
      ...old,
      {
        stepperTitle,
        step,
      },
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepperTitle]);

  const handleClick = (step) => {
    // Move to the certain step and also move the stepper bar to match the step
    setStepFlow(step);
    setStepSidebar(step);
    // filter the array so the user when move to a certain step does not render
    // the steps after the one the user moves
    setTitlesArr((old) => old.filter((_, index) => index < step + 1));
  };

  const handlePush = (path, index) => {
    crumbsArr.splice(index, crumbsArr.length);
    history.push(path);
  };

  // Don't render a single breadcrumb.
  // if (titlesArr.filter((_, index) => index !== 0).length <= 1) {
  //   return null;
  // }

  return (
    <Grid container justifyContent="center" alignItems="center">
      <Grid item>
        <Stack direction="row">
          <Breadcrumbs
            maxItems={5}
            separator={
              <NavigateNextIcon fontSize="small" sx={{ color: '#FA6400' }} />
            }
          >
            {/* TODO: check props so the component do not breaks when
                don't have the necessary props to render
            */}
            {isWorkflow
              ? titlesArr
                  .filter((_, index) => index !== 0)
                  .map((title, index) => {
                    return (
                      <Link
                        underline="hover"
                        // show last one active
                        color={
                          index === titlesArr.length - 2
                            ? 'text.primary'
                            : 'inherit'
                        }
                        onClick={() => handleClick(title.step)}
                      >
                        {title.stepperTitle}
                      </Link>
                    );
                  })
              : crumbsArr
                  .filter(
                    (crumb, index) =>
                      crumb.name && crumb.isActive && crumb.hasBeenActive
                  )
                  // .sort((a, b) => a.order - b.order)
                  .map((crumb, index) => {
                    return (
                      <Link
                        underline="hover"
                        // show last one active
                        color={
                          crumb.path === activePath ? 'text.primary' : 'inherit'
                        }
                        onClick={() => handlePush(crumb.path, index)}
                      >
                        {crumb.name}
                      </Link>
                    );
                  })}
          </Breadcrumbs>
        </Stack>
      </Grid>
    </Grid>
  );
};
export default CustomBreadcrumbs;
